import React from 'react';
import { tokenStats } from '../siteData';
import Icon from './Icon';
import { ExternalLink } from './Shared';
export default function Tokenomics() {
  return <section id="tokenomics" className="container tokenomics" aria-label="Tokenomics">
    <div className="trust-grid">{tokenStats.map(stat => <div className="trust-stat" key={stat.label}>
      <div className="stat-label"><Icon name={stat.icon} /><span>{stat.label}</span></div>
      <p className="stat-value">{stat.value}</p>
      {stat.href ? <ExternalLink className="stat-detail" href={stat.href}>{stat.detail} <Icon name="external" /></ExternalLink> : <span className="stat-detail">{stat.detail}</span>}
    </div>)}</div>
    <p className="stats-note">Figures and status from the project's published tokenomics. Circulating supply is not a live feed.</p>
  </section>;
}
